<div class="autocomplete-field">
    <div class="formula-input">
        <mat-form-field class="form-field">
            <input
                (input)="onFormulaInput($event)"
                matInput
                [placeholder]="'formulas.formula' | translate"
                [attr.aria-label]="'formulas.formula' | translate"
                [value]="currentFormula() ? (currentFormula() | json) : ''" />
            <button
                mat-icon-button
                matSuffix
                [attr.aria-label]="'formulas.tooltips.formulaHelper' | translate"
                (click)="openFormulaHelper()">
                <mat-icon aria-hidden="true">functions</mat-icon>
            </button>
        </mat-form-field>
    </div>
</div>
